module.exports = __webpack_public_path__ + "img/second.e4235bed.png";